import React, { useEffect } from 'react';
import Link from '@/components/buttons/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSelector } from 'react-redux';
import { sampleSetDataCurrentSelector, sampleSetDataDataSelector } from '@/redux/selectors/sampleSetData.selector.js';
import { useBiovizStatus } from '../../lenses/uilenses/hooks/biovizStatus/biovizStatus.hook.js';
import { useAuth0 } from '@auth0/auth0-react';
import Cookies from 'universal-cookie';

export const BinfButton = ({ ...props }) => {
  const domain = window.location.hostname === "localhost" ? "localhost" : "metabolon.com";
  const sampleSetData = useSelector(sampleSetDataDataSelector);
  const current = useSelector(sampleSetDataCurrentSelector);
  const projectId = sampleSetData[current]?.projectId;
  const sampleSetId = sampleSetData[current]?.sampleSetId;
	const {status: biovizStatus, href} = useBiovizStatus(projectId);
	const { getAccessTokenSilently, isAuthenticated } = useAuth0();
	const db = new Cookies();

  useEffect(() => {
		if (!isAuthenticated) {
			return; // Skip if not authenticated
		}
		
		const setCookie = async () => {
			try {
				const token = await getAccessTokenSilently({
					audience: 'https://portal-api'
				});
				if (token) {
					db.set(`binf_auth_cookie`, token, {
						path:'/',
						sameSite:'strict',
						domain,
						secure: true
					});
				}
			} catch (error) {
				if (error.error === 'login_required' || error.message?.includes('login_required')) {
					console.log('⚠️  BinfButton: Login required - skipping cookie set');
					return;
				}
				console.error('❌ BinfButton: Error getting token for binf_auth_cookie:', error);
			}
		};
		setCookie();
  }, [db, domain, getAccessTokenSilently, isAuthenticated]);
  if (!biovizStatus) return null;

  return (
    <Link href={href} target="_self" rel="noopener noreferrer" underline="none" {...props} >BioInformatics {<OpenInNewIcon color="white" viewBox={"0 0 30 30"} />}</Link>);
};

export default BinfButton;